import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ChevronLeft, Plus } from 'lucide-react';
import { useFolders } from '../../hooks/useFolders';
import { ButtonPanel } from '../ButtonPanel';

export const FoldersScreen = () => {
  const navigate = useNavigate();
  const { folders } = useFolders();

  return (
    <div className="min-h-screen bg-gray-50 p-4 md:p-6">
      {/* Header */}
      <div className="flex items-center justify-between mb-6">
        <div className="flex items-center gap-3">
          <button
            onClick={() => navigate('/')}
            className="p-2 hover:bg-gray-200 rounded-lg transition"
          >
            <ChevronLeft className="text-gray-700" size={24} />
          </button>
          <h1 className="text-2xl font-bold text-gray-900">Mis Carpetas</h1>
        </div>
        <button
          onClick={() => navigate('/add-folder')}
          className="p-2 bg-blue-500 hover:bg-blue-600 text-white rounded-lg transition"
        >
          <Plus size={24} />
        </button>
      </div>

      {/* Folders List */}
      <div className="grid gap-4">
        {folders.length === 0 ? (
          <div className="text-center py-12">
            <p className="text-gray-500 text-lg">No tienes carpetas aún</p>
            <p className="text-gray-400 text-sm mt-2">Crea tu primera carpeta para organizar paradas</p>
            <button
              onClick={() => navigate('/add-folder')}
              className="mt-4 px-6 py-2 bg-blue-500 hover:bg-blue-600 text-white rounded-lg transition font-semibold"
            >
              Crear Carpeta
            </button>
          </div>
        ) : (
          folders.map((folder) => (
            <ButtonPanel
              key={folder.id}
              onClick={() => navigate(`/folder/${folder.id}`)}
              title={folder.name}
              subtitle={`${folder.stopCount} parada${folder.stopCount !== 1 ? 's' : ''}`}
              color={folder.color}
              leftIcon="📁"
            />
          ))
        )}
      </div>
    </div>
  );
};
